import React from "react";

/**
 * DragHandle Component
 * 
 * Renders:
 * - A gray drag handle grid of dots (⠿).
 * - Styled to be invisible by default, and visible only on parent hover (via Tailwind group-hover:visible).
 */
export function DragHandle() {
  return (
    <span
      className="hidden md:inline-block invisible group-hover:visible text-gray-400 select-none cursor-grab active:cursor-grabbing text-lg font-bold"
      aria-hidden="true"
    >
      ⠿
    </span>
  );
}
